export { subscribe, createSourceEventStream } from './subscribe';



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/subscription/index.mjs
// module id = 226
// module chunks = 17